import * as React from 'react';
import {
  BaSeCard,
  BaSeGrid,
  BaSeGridItem,
  BaSeSmall1,
  BaSeShapeButton,
  BaSeTheme,
} from '@base/react';
import { ClientWrapper, WrapperActions } from '../certificados-cliente-styled';
import { formatDate } from '../utils/certificados.utils';
import { StatusBadge } from './StatusBadge';

const { cinzaSebrae28, cinzaSebrae30, cinzaSebrae60 } =
  BaSeTheme.colors.institucionais;

const FieldLabel = ({ label, value }) => (
  <ClientWrapper>
    <BaSeSmall1 color={cinzaSebrae30}>{label}</BaSeSmall1>
    <BaSeSmall1 color={cinzaSebrae28}>{value}</BaSeSmall1>
  </ClientWrapper>
);

const CardActionsMenu = ({ actions }) => (
  <WrapperActions>
    {actions.map((action, i) => (
      <BaSeShapeButton
        key={i}
        color={cinzaSebrae60}
        type="tertiary"
        shape="circle"
        size="small"
        sizeIcon="medium"
        nameIcon={action.icon}
        onClick={action.callback}
      />
    ))}
  </WrapperActions>
);

export const CertificadoCard = ({ values, actions }) => (
  <BaSeCard
    disposition="stacked"
    elevationOnHoverOrFocus
    width="100%"
    destakColor="default"
    withSideDestak={false}
    renderContentAction={() =>
      actions.length > 0 && <CardActionsMenu actions={actions} />
    }
    renderContentInfo={() => (
      <BaSeGrid>
        <BaSeGridItem desktop={{ size: 12 }}>
          <FieldLabel
            label="Código do produto:"
            value={values?.codigoProduto ?? '-'}
          />
          <FieldLabel label="Produto:" value={values?.nomeProduto ?? '-'} />
          <FieldLabel label="Template:" value={values?.tipo ?? '-'} />
          <FieldLabel
            label="Carga horária:"
            value={values?.cargaHoraria ?? '-'}
          />
          <FieldLabel
            label="Data de conclusão:"
            value={formatDate(values?.dataConclusao)}
          />
          <ClientWrapper>
            <BaSeSmall1 color={cinzaSebrae30}>Status:</BaSeSmall1>
            <StatusBadge ativo={values?.ativo ?? true} />
          </ClientWrapper>
        </BaSeGridItem>
      </BaSeGrid>
    )}
  />
);
